// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"ER-z","inlineTitle":"FR-z","sponsoredAdsWrapper":"GR-z","marketplaceRecosWrapper":"HR-z"};